import React from "react";

import { useHotKeys } from "App/common/hooks/hotKeys";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { validateEmail } from "./../../../../../../../utils";
import { VALIDATION } from "../../../../../../../consts";
import { SPopupContext } from "App/common/hoc/SlidingPopup";
import { deepClone } from "utils";

function BackupPlanEmailNotification(props) {
  const [invalidEmail, setInvalidEmail] = React.useState({
    show: false,
    msg: ""
  });
  const { sPopupState } = React.useContext(SPopupContext);
  const [operationStatus, setOperationStatus] = React.useState(
    props.planSettings.emailNotification.operationStatus === 0
      ? { onSuccess: true, onFailure: true }
      : props.planSettings.emailNotification.operationStatus === 1
      ? { onSuccess: true, onFailure: false }
      : props.planSettings.emailNotification.operationStatus === 2
      ? { onSuccess: false, onFailure: true }
      : { onSuccess: false, onFailure: false }
  );

  function validate() {
    let emailsList = deepClone(
      props.planSettings.emailNotification.current
    ).split(",");
    let correctEmails = [];
    let wrongEmails = [];
    let duplicateEmails = [];
    for (let i = 0; i < emailsList.length; i++) {
      if (!validateEmail(emailsList[i].replace(" ", ""))) {
        setInvalidEmail({
          show: true,
          msg: VALIDATION.backupSettings.email.valid
        });
        wrongEmails.push(emailsList[i].replace(" ", ""));
      } else {
        if (
          props.planSettings.emailNotification.emails.filter(
            email =>
              email.toLowerCase() ===
              emailsList[i].replace(" ", "").toLowerCase()
          ).length > 0 ||
          correctEmails.filter(
            email =>
              email.toLowerCase() ===
              emailsList[i].replace(" ", "").toLowerCase()
          ).length > 0
        ) {
          duplicateEmails.push(emailsList[i].replace(" ", ""));
        } else correctEmails.push(emailsList[i].replace(" ", ""));
      }
    }
    let tempPlan = { ...props.planSettings };
    wrongEmails.push.apply(wrongEmails, duplicateEmails);
    tempPlan.emailNotification.emails.push.apply(
      props.planSettings.emailNotification.emails,
      correctEmails
    );
    tempPlan.emailNotification.current = wrongEmails.join(",");
    props.setPlanSettings(tempPlan);
    if (duplicateEmails.length > 0) {
      setInvalidEmail({
        show: true,
        msg: VALIDATION.backupSettings.email.duplicate
      });
    }
  }

  function removeEmailFromTheList(index) {
    let tempPlan = { ...props.planSettings };
    tempPlan.emailNotification.emails.splice(index, 1);
    props.setPlanSettings(tempPlan);
  }

  function updatedOperationsStatus() {}

  useHotKeys(
    "enter",
    () => {
      validate();
    },
    []
  );

  function updateValidation(type) {
    if (sPopupState.validation.params) {
      switch (type) {
        case "username":
          if (sPopupState.validation.params.username) {
            sPopupState.validation.params.username.check = false;
            sPopupState.validation.params.username.msg = "";
          }
          break;
        case "password":
          if (sPopupState.validation.params.password) {
            sPopupState.validation.params.password.check = false;
            sPopupState.validation.params.password.msg = "";
          }
          break;
        case "servername":
          if (sPopupState.validation.params.servername) {
            sPopupState.validation.params.servername.check = false;
            sPopupState.validation.params.servername.msg = "";
          }
          break;
        case "port":
          if (sPopupState.validation.params.port) {
            sPopupState.validation.params.port.check = false;
            sPopupState.validation.params.port.msg = "";
          }
          break;
        default:
          break;
      }
    }
  }

  function updateOperationStatus(type, value) {
    let temp = { ...operationStatus };
    if (type === "onSuccess") {
      temp.onSuccess = !operationStatus.onSuccess;
    } else if (type === "onFailure") {
      temp.onFailure = !operationStatus.onFailure;
    }
    setOperationStatus(temp);
    updatePlanSettings(temp);
  }

  function updatePlanSettings(operationStatus) {
    if (operationStatus.onSuccess && operationStatus.onFailure) {
      props.setPlanSettings({
        ...props.planSettings,
        emailNotification: {
          ...props.planSettings.emailNotification,
          operationStatus: 0
        }
      });
    } else {
      if (operationStatus.onSuccess)
        props.setPlanSettings({
          ...props.planSettings,
          emailNotification: {
            ...props.planSettings.emailNotification,
            operationStatus: 1
          }
        });
      else if (!operationStatus.onSuccess && operationStatus.onFailure) {
        props.setPlanSettings({
          ...props.planSettings,
          emailNotification: {
            ...props.planSettings.emailNotification,
            operationStatus: 2
          }
        });
      } else
        props.setPlanSettings({
          ...props.planSettings,
          emailNotification: {
            ...props.planSettings.emailNotification,
            operationStatus: 3
          }
        });
    }
  }

  React.useEffect(() => {
    if (sPopupState.validation.params && sPopupState.validation.params.email)
      setInvalidEmail(sPopupState.validation.params.email);
  }, [sPopupState.validation.params.email]);

  return (
    <div className="plan_cont_blk">
      <div className="createBkp-cont">
        <div className="summary_wrap_body">
          <div className="send_email svg_icon">
            <p>
              Send email notification
              <Tooltip {...TOOLTIPS.backupSettings.email.notification}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            </p>
            <div className="send_email_int_btn just_flex">
              <div className="err_msg_wrap">
                <input
                  type="text"
                  className="input_text"
                  onChange={e => {
                    setInvalidEmail(prevState => ({
                      ...prevState,
                      show: false
                    }));
                    props.setPlanSettings({
                      ...props.planSettings,
                      emailNotification: {
                        ...props.planSettings.emailNotification,
                        current: e.target.value
                      }
                    });
                  }}
                  value={
                    props.planSettings.emailNotification.current
                      ? props.planSettings.emailNotification.current
                      : ""
                  }
                  autoFocus={true}
                  tabIndex={0}
                />
                <div>
                  {invalidEmail.show && (
                    <span className={"error-msg active"}>
                      {invalidEmail && invalidEmail.msg !== ""
                        ? invalidEmail.msg
                        : VALIDATION.backupSettings.email.error}
                    </span>
                  )}
                </div>
              </div>
              <Tooltip {...TOOLTIPS.backupPlan.settings.addemail}>
                <button
                  className="slider_btn btn_primary email_add"
                  onClick={validate}
                  tabIndex={0}
                >
                  Add
                </button>
              </Tooltip>
            </div>
            <p className="email_msg_wrap">
              Add multiple email addresses, separated by comma.
            </p>
            {props.planSettings.emailNotification.emails.length > 0 ? (
              <div className="int_email_chips active">
                {props.planSettings.emailNotification.emails.map((email, i) => {
                  return (
                    <div className="chip" key={i}>
                      <p>{email}</p>
                      <span
                        className="chip_close"
                        onClick={() => removeEmailFromTheList(i)}
                      />
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>

          {/* smtp */}
          <div className="smpt_settings">
            <div className="sub_title">SMTP Settings</div>
            <div className="en_inpt just_flex">
              <div className="check">
                <input
                  type="checkbox"
                  className="input_checkbox"
                  id="smtp_enable"
                  tabIndex={0}
                  visibility="block"
                  defaultChecked={
                    props.planSettings.emailNotification.smtpSettings.isEnabled
                  }
                  onChange={() =>
                    props.setPlanSettings({
                      ...props.planSettings,
                      emailNotification: {
                        ...props.planSettings.emailNotification,
                        smtpSettings: {
                          ...props.planSettings.emailNotification.smtpSettings,
                          isEnabled: !props.planSettings.emailNotification
                            .smtpSettings.isEnabled
                        }
                      }
                    })
                  }
                />
                <label htmlFor="smtp_enable" id="smtp_enable_label"></label>
              </div>
              <p className="checkbox_p">Custom SMTP settings</p>
            </div>

            <div
              className={[
                "smpt_form",
                props.planSettings.emailNotification.smtpSettings.isEnabled
                  ? ""
                  : "transparent_layer_wrap"
              ].join(" ")}
            >
              <div
                className="transparent_layer"
                style={{
                  display: props.planSettings.emailNotification.smtpSettings
                    .isEnabled
                    ? "none"
                    : "block"
                }}
              ></div>
              <div className="ens_wrap">
                <div className="ens_item">
                  <p>Server Name</p>
                  <div className="err_msg_wrap">
                    <input
                      type="text"
                      className="input_text"
                      value={
                        props.planSettings.emailNotification.smtpSettings
                          .serverName
                      }
                      maxLength={50}
                      onChange={e => {
                        props.setPlanSettings({
                          ...props.planSettings,
                          emailNotification: {
                            ...props.planSettings.emailNotification,
                            smtpSettings: {
                              ...props.planSettings.emailNotification
                                .smtpSettings,
                              serverName: e.target.value
                            }
                          }
                        });
                        updateValidation("servername");
                      }}
                    />
                    {props.planSettings.emailNotification.smtpSettings
                      .isEnabled &&
                      !sPopupState.validation.status &&
                      sPopupState.validation.params.servername &&
                      sPopupState.validation.params.servername.check && (
                        <div>
                          <span className="error-msg active">
                            {sPopupState.validation.params.servername.msg}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <div className="ens_item">
                  <p>Port</p>
                  <div className="err_msg_wrap">
                    <input
                      type="number"
                      className="input_number"
                      min="0"
                      value={
                        props.planSettings.emailNotification.smtpSettings.port
                      }
                      maxLength={5}
                      onChange={e => {
                        props.setPlanSettings({
                          ...props.planSettings,
                          emailNotification: {
                            ...props.planSettings.emailNotification,
                            smtpSettings: {
                              ...props.planSettings.emailNotification
                                .smtpSettings,
                              port: +e.target.value
                            }
                          }
                        });
                        updateValidation("port");
                      }}
                    />
                    {props.planSettings.emailNotification.smtpSettings
                      .isEnabled &&
                      !sPopupState.validation.status &&
                      sPopupState.validation.params.port &&
                      sPopupState.validation.params.port.check && (
                        <div>
                          <span className="error-msg active">
                            {sPopupState.validation.params.port.msg}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="ens_wrap">
                <div className="ens_item">
                  <p>Username</p>
                  <div className="err_msg_wrap">
                    <input
                      type="text"
                      className="input_text"
                      value={
                        props.planSettings.emailNotification.smtpSettings
                          .userName
                      }
                      maxLength={50}
                      onChange={e => {
                        props.setPlanSettings({
                          ...props.planSettings,
                          emailNotification: {
                            ...props.planSettings.emailNotification,
                            smtpSettings: {
                              ...props.planSettings.emailNotification
                                .smtpSettings,
                              userName: e.target.value
                            }
                          }
                        });
                        updateValidation("username");
                      }}
                    />
                    {props.planSettings.emailNotification.smtpSettings
                      .isEnabled &&
                      !sPopupState.validation.status &&
                      sPopupState.validation.params.username &&
                      sPopupState.validation.params.username.check && (
                        <div>
                          <span className="error-msg active">
                            {sPopupState.validation.params.username.msg}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
                <div className="ens_item">
                  <p>Password</p>
                  <div className="err_msg_wrap">
                    <input
                      type="password"
                      className="input_password"
                      value={
                        props.planSettings.emailNotification.smtpSettings
                          .password
                      }
                      maxLength={50}
                      onChange={e => {
                        props.setPlanSettings({
                          ...props.planSettings,
                          emailNotification: {
                            ...props.planSettings.emailNotification,
                            smtpSettings: {
                              ...props.planSettings.emailNotification
                                .smtpSettings,
                              password: e.target.value
                            }
                          }
                        });
                        updateValidation("password");
                      }}
                    />
                    {props.planSettings.emailNotification.smtpSettings
                      .isEnabled &&
                      !sPopupState.validation.status &&
                      sPopupState.validation.params.password &&
                      sPopupState.validation.params.password.check && (
                        <div>
                          <span className="error-msg active">
                            {sPopupState.validation.params.password.msg}
                          </span>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="en_advence">
            <div className="sub_title">Backup Notifications</div>
            <div className="en_inpt just_flex">
              <div className="check">
                <input
                  type="checkbox"
                  className="input_checkbox"
                  id="email_notification_21"
                  defaultChecked={operationStatus.onSuccess}
                  onClick={e => {
                    updateOperationStatus("onSuccess", e.target.value);
                  }}
                />
                <label htmlFor="email_notification_21"></label>
              </div>
              <p className="checkbox_p">Notify when backup succeeds</p>
            </div>
            <div className="en_inpt just_flex">
              <div className="check">
                <input
                  type="checkbox"
                  className="input_checkbox"
                  id="email_notification_22"
                  defaultChecked={operationStatus.onFailure}
                  onChange={e => {
                    updateOperationStatus("onFailure", e.target.value);
                  }}
                />
                <label htmlFor="email_notification_22"></label>
              </div>
              <p className="checkbox_p">Notify when backup fails</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BackupPlanEmailNotification;
